import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer">
            <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
              黑
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
                黑料在线
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.3em] text-secondary-500 uppercase">
                Archive
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#timeline"
              aria-label="检索归档"
              className="hidden sm:flex w-10 h-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </a>
            <a
              href="#subscribe"
              className="hidden sm:inline-flex items-center gap-2 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-bookmark-line" />
              订阅更新
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-100 whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#subscribe"
            onClick={() => setMenuOpen(false)}
            className="mt-4 flex items-center justify-center gap-2 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-bookmark-line" />
            订阅归档更新
          </a>
        </div>
      )}
    </header>
  );
}